import Chart from 'chart.js/auto';
import {AlgoBase} from "./AlgoBase";
import userCombinations from "/data/user_combinations.json";

export class Occam2ChartJS extends AlgoBase {

  constructor(target) {
    super("occam", target);
    this.init();
  }

  async init() {

    this.algortihmData = await this.buildDataset("data/algorithms/Occam2.csv");

    const ctx = this.$widget.find("canvas");

    this.chart = new Chart(ctx, {
      type: 'line',
      data: {
        labels: this.algortihmData.labels,
        datasets: [{
          label: 'DUCT / SAP', // [dynamic value in loadDataset()],
          data: this.algortihmData.mainDatasets[0],
          borderColor: '#000000',
        },{
          label: 'Average Zone Damper Position %', // [dynamic value in loadDataset()],
          data: this.algortihmData.averageDatasets[0],
          borderColor: '#EB2B31',
          yAxisID: 'yRight',
        }]
      },
      options: {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
          legend: {
            labels: {
              padding: 18,
            }
          },
          annotation: {
            annotations: {
              line1: {
                type: 'line',
                title: "Maximum reset", // [dynamic value in loadDataset()],
                yMin: 1.5,
                yMax: 1.5,
                borderColor: '#EB2B31',
                borderDash: [4, 4],
                drawTime: 'beforeDraw',
                z: 1,
              },
              line2: {
                type: 'line',
                title: "Minimum reset", // [dynamic value in loadDataset()],
                yMin: 0.5,
                yMax: 0.5,
                borderColor: '#000000',
                borderDash: [4, 4],
                drawTime: 'beforeDraw',
                z: 1,
              },
              box1: {
                type: 'box',
                borderWidth: 0,
                xMin: 36,
                xMax: null,
                yMin: 0,
                yMax: 2,
                backgroundColor: 'rgba(255, 42, 42, 0.3)',
                drawTime: 'beforeDraw',
                z: 0,
                label: {
                  display: true,
                  position: 'center',
                  drawTime: 'afterDraw',
                  z: 2,
                  rotation: -90,
                  content: "Occupied", // [dynamic value in loadDataset()],
                  color: '#000000',
                  font: Chart.defaults.plugins.annotation.common.label.font,
                  beforeDraw: (context, rect) => this.drawLabelBackground(context, rect, 'rgb(245 182 183 / 0.80)')
                },
              },
            },
          },
          title: {
            display: true,
            text: 'OAT', // [dynamic value in loadDataset()],
          }
        },
        elements: {
          line: {
            tension: 0.3,
            borderColor: '#330808',
          }
        },
        scales: {
          x: this.setupXAxis(this.algortihmData.labels.length / 3),
          y: {
            min: 0,
            max: 2,
            ticks: {
              callback: function (value, index, ticks) {
                return value + ' in H2O';
              }
            },
          },
          yRight: {
            position: 'right',
            min: 0,
            max: 100,
            ticks: {
              callback: function (value, index, ticks) {
                return value + ' %';
              }
            },
          }



          // this.chart.data.datasets[0].label = 'Average Zone Damper Position';
          // this.chart.options.scales.y.min = 0;
          // this.chart.options.scales.y.max = 100;
          // this.chart.options.scales.y.ticks.callback =  function (value, index, ticks) {
          //   return value + '%';
          // };
        }
      }
    });

    this.loadDataset(0)

    this.initEvents();

    this.ready();
  }

  loadDataset(datasetIndex) {
    const offset = (this.aiEnabled ? 0 : this.getLoopIndex());
    this.chart.data.datasets[1].data = this.algortihmData.averageDatasets[datasetIndex + offset];

    // Update dynamic strings from CMS
    this.chart.data.datasets[0].label =  (this.aiEnabled)  ? this.getLegendFromCMS(1, 2) : this.getLegendFromCMS(6, 2) ;
    this.chart.data.datasets[1].label = this.getLegendFromCMS(2, 2);
    this.chart.options.plugins.annotation.annotations.line1.title = this.getLegendFromCMS(3, 2);
    this.chart.options.plugins.annotation.annotations.line2.title = this.getLegendFromCMS(4, 2);
    const userCombinationData = userCombinations[this.algorithmName][datasetIndex];
    this.chart.options.plugins.annotation.annotations.box1.label.content = this.getLegendFromCMS(5, 2).toUpperCase().replace("%", userCombinationData.title);

    this.chart.options.plugins.title.text = this.getLegendFromCMS(6, 2)?.toUpperCase();

    super.loadDataset(datasetIndex);
  }

  async buildDataset(filename) {
    const singleDataSetBuild = await super.buildDatasetFromCSV(filename, 2);
    return {
      labels: singleDataSetBuild.labels,
      mainDatasets: singleDataSetBuild.allDatasets[0],
      averageDatasets: singleDataSetBuild.allDatasets[1],
    };
  }

}
